export class SidebarResizeHandler {
    constructor(host, getSidebarPosition, getSidebarWidth, setSidebarWidth) {
        this.host = host;
        this.getSidebarPosition = getSidebarPosition;
        this.getSidebarWidth = getSidebarWidth;
        this.setSidebarWidth = setSidebarWidth;
        this.isResizing = false;
        this.startX = 0;
        this.startWidth = 0;
        this.maxWidth = 0;
        this.startResize = (event) => {
            this.isResizing = true;
            this.startX = event.clientX;
            this.startWidth = parseInt(this.getSidebarWidth() || '0', 10);
            document.body.style.cursor = 'col-resize';
            event.preventDefault();
        };
        this.handleResize = (event) => {
            if (!this.isResizing) {
                return;
            }
            const sidebarPosition = this.getSidebarPosition();
            const dx = event.clientX - this.startX;
            const isRtl = document.documentElement.getAttribute('dir') === 'rtl';
            const directionMultiplier = isRtl ? -1 : 1;
            const positionMultiplier = sidebarPosition === 'left' ? 1 : -1;
            const newWidth = this.startWidth + dx * directionMultiplier * positionMultiplier;
            window.requestAnimationFrame(() => {
                if (newWidth >= 240 && newWidth <= this.maxWidth) {
                    this.setSidebarWidth(String(newWidth));
                }
            });
            event.preventDefault();
        };
        this.stopResize = () => {
            this.isResizing = false;
            document.body.style.cursor = '';
        };
        this.handleWindowResize = () => {
            this.calculateMaxWidth();
            const currentWidth = parseInt(this.getSidebarWidth() || '0', 10);
            if (currentWidth > this.maxWidth) {
                this.setSidebarWidth(String(this.maxWidth));
            }
        };
    }
    initResize() {
        var _a;
        const resizeBorder = (_a = this.host.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById('resize-border');
        if (resizeBorder) {
            resizeBorder.addEventListener('mousedown', this.startResize);
        }
        document.addEventListener('mouseup', this.stopResize);
        document.addEventListener('mousemove', this.handleResize);
        window.addEventListener('resize', this.handleWindowResize);
        this.calculateMaxWidth();
    }
    calculateMaxWidth() {
        var _a;
        this.maxWidth = Math.floor((((_a = this.host.parentElement) === null || _a === void 0 ? void 0 : _a.offsetWidth) || window.innerWidth) * 0.7);
    }
    destroy() {
        window.removeEventListener('resize', this.handleWindowResize);
        document.removeEventListener('mouseup', this.stopResize);
        document.removeEventListener('mousemove', this.handleResize);
    }
}
